goog.provide('el8.ptdata.visitNoteEdits');
goog.provide('el8.ptdata.model.note.visitNoteEdit');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.data.referencedUsers');


/**
 * So this is an EntitySet that we are using largely for just holding data.
 * It doesn't remove items from itself actively, so it may contained deleted Edits
 */
el8.ptdata.visitNoteEdits = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('visitNoteId');
    _class.addIntProperty('createUserId');
    _class.addDateTime('createDate');

    _class.addDateTime('previousNoteTime');
    _class.addDateTime('newNoteTime');

    _class.addIntProperty('previousNoteTypeId');
    _class.addIntProperty('newNoteTypeId');

    _class.addStringProperty('previousBmi');
    _class.addStringProperty('newBmi');

    _class.addStringProperty('previousPrevWeight');
    _class.addStringProperty('newPrevWeight');

    _class.addStringProperty('previousPrevBmi');
    _class.addStringProperty('newPrevBmi');

    _class.addDateTime('previousPrevTime');
    _class.addDateTime('newPrevTime');

    _class.prototype.getVisitNote = function(force) {
        var that = this;
        var note = el8.ptdata.tempVisitNotes.getById(this.getVisitNoteId());
        if (!note || force) {
            $.el8_ajax({
                type: 'POST',
                async: false,
                url: el8.service.urls.get('fetchVisitNoteEdit', [this.getVisitNoteId()+'-'+this.getId()]),
                success: function(data) {
                    note = el8.ptdata.tempVisitNotes.create(data, true);
                }
            });
        }
        note.setCurrentEditId(that.getId());
        return note;
    };
    _class.prototype.getDescription = function() {
        var note = this.getVisitNote();
        return 'Amendment of ' + note.getDocumentDate().asString() + ' Visit Note';
    };
    _class.prototype.getCreateUserName = function() {
        return this.getCreateUserId() ? 
                    el8.data.referencedUsers.getById(this.getCreateUserId()).getFullName() : null;
    };

    _class.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);
        m['createUserName'] = this.getCreateUserName();
        m['signUserName'] = this.isSignedOff() ? this.getSignUserName() : null;
        return m;
    };

    el8.ptdata.model.note.visitNoteEdit = function(spec) { return new _class(spec); };

    return new el8_EntitySet({
        model: el8.ptdata.model.note.visitNoteEdit
    });

})();

